module.exports = __webpack_public_path__ + "img/1787896020621692929.ba774ca1.png";